import CheckmarkCircleIconPath from "@ingka/ssr-icon/paths/checkmark-circle";

export default CheckmarkCircleIconPath;
